  import React, { useState, useEffect } from "react";
  import Sidebar from './Sidebar';
  import "../Admin/css/layout.css";
  import "../Admin/css/complaint.css";
  import Header from "./Header";
  import { secureStorage } from '../utils/secureStorage';
  import { createComplaint, getComplaints, updateRating, deleteComplaint   } from "../service/complaintService";
  import { LuMessageSquareMore } from "react-icons/lu";
  import { FaSmile, FaGrinStars, FaMeh, FaFrown } from "react-icons/fa";
  import {FaClipboardList,FaClock,FaSpinner,FaCheckCircle} from "react-icons/fa";
  import { useNavigate } from "react-router-dom";

  const Complaintregister = () => {
    
  const navigate = useNavigate();
  const [complaints, setComplaints] = useState([]);     
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const scholar = secureStorage.getScholar();
  const scholarId = scholar?.id;
  const date = new Date().toISOString().split('T')[0];
  const [showPopup, setShowPopup] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState("");
  const [showRatingPopup, setShowRatingPopup] = useState(false);
  const [selectedComplaintId, setSelectedComplaintId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const complaintsPerPage = 10;
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [filterStatus, setFilterStatus] = useState("All");
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
  subject: "", 
    description: "",
  
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    try {
      if (!scholarId) {
        alert("Scholar ID not found");
        return;
      }

      const res = await createComplaint({
      
        complaint: formData.description,
      reg_id: scholarId,
        user_id: scholar.user_id,
        complt_reg_dt: date
      });

       // Reload complaints from API
    await fetchComplaints();

      //const newData = res.data?.data || res.data;

      //setComplaints((prev) => [newData, ...prev]);

      setShowModal(false);
      setFormData({
        subject: "",
        description: "",
      
      });
 // show success modal
    setShowSuccess(true);

    // auto close success modal
    setTimeout(() => {
      setShowSuccess(false);
    }, 2500);

    } catch (err) {
      console.error("CREATE ERROR:", err.response?.data);
    }
  };

  useEffect(() => {
    if (scholarId) {
      fetchComplaints();
    }
  }, [scholarId]);

  const fetchComplaints = async () => {
    try {
        setLoading(true);
      if (!scholarId) return;

      const res = await getComplaints(scholarId);

      const list = res.data?.data || [];

      setComplaints(list);

    } catch (err) {
      console.error("FETCH ERROR:", err.response?.data);
    }
     finally {
      setLoading(false);
    }
  };
  const statses = [
    { label: "Total Complaints", value: complaints.length, icon: <FaClipboardList />, color: "#2563eb" },
    { label: "Pending", value: complaints.filter(c => c.status === "Pending").length,icon: <FaClock />, color: "#f59e0b" },
    { label: "In Progress", value: complaints.filter(c => c.status === "In Progress").length, icon: <FaSpinner />, color: "#8b5cf6" },
    { label: "Resolved", value: complaints.filter(c => c.status === "Resolved").length, icon: <FaCheckCircle />,color: "#10b981" },
  ];

  const handleView = (c) => {
    setSelectedComplaint(c);
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setSelectedComplaint(null);
  };

  const getRatingLabel = (rating) => {
  switch (Number(rating)) {
    case 5:
      return "Excellent";
    case 4:
      return "Good";
    case 3:
      return "Average";
    case 2:
      return "Bad";
    case 1:
      return "Poor";
    default:
      return "";
  }
};

 const handleRating = async (value) => {
  try {
    const ratingMap = {
      Excellent: 5,
      Good: 4,
      Average: 3,
      Bad: 2,
      Poor: 1
    };

    const numericRating = ratingMap[value];

    await updateRating(selectedComplaintId, {
      ratings: numericRating,
      reg_id: scholar?.id,
      user_id: scholar?.user_id
    });

    await fetchComplaints(); // Refresh table

    setShowRatingPopup(false);
     setComplaints((prev) =>
  prev.map((c) =>
    c.id === selectedComplaintId
      ? { ...c, rating: numericRating }
      : c
  )
);

  } catch (err) {
    console.error("RATING ERROR:", err.response?.data);
  }
};


  

const handleDelete = async () => {  
  try {
    await deleteComplaint(deleteId);

    setComplaints((prev) =>
      prev.filter((c) => c.ticket_id !== deleteId)
    );
     setShowDeletePopup(false);
    setDeleteId(null);

  } catch (err) {
    console.error("DELETE ERROR:", err.response?.data);
  }
};

// Filter Complaints
const filteredComplaints =
  filterStatus === "All"
    ? complaints
    : complaints.filter(
        (c) =>
          c.status?.toLowerCase() ===
          filterStatus.toLowerCase()
      );

// Pagination Logic
const indexOfLastComplaint =
  currentPage * complaintsPerPage;

const indexOfFirstComplaint =
  indexOfLastComplaint - complaintsPerPage;

const currentComplaints =
  filteredComplaints.slice(
    indexOfFirstComplaint,
    indexOfLastComplaint
  );

const totalPages = Math.ceil(
  filteredComplaints.length / complaintsPerPage
);

useEffect(() => {
  const scholar = secureStorage.getScholar();

  if (!scholar) {
    navigate("/", { replace: true });
  }
}, [navigate]);


const getRatingDisplay = (rating) => {
  switch (Number(rating)) {
    case 5:
      return {
        text: "Excellent",
        color: "#16a34a",
        icon: <FaGrinStars />
      };

    case 4:
      return {
        text: "Good",
        color: "#2238c5",
        icon: <FaSmile />
      };

    case 3:
      return {
        text: "Average",
        color: "#f59e0b",
        icon: <FaMeh />
      };

    case 2:
      return {
        text: "Bad",
        color: "#ef4444",
        icon: <FaFrown />
      };

    case 1:
      return {
        text: "Poor",
        color: "#000000",
        icon: <FaFrown />
      };

    default:
      return {
        text: "Give Rating",
        color: "#2563eb",
        icon: null
      };
  }
};

 // Loading state
   if (loading) {
    return (
      <>
        <div className="layout">
          <Sidebar />
          <div className="main-area">
            <Header />
        <div className="modern-loader-container">
     <div className="modern-loader-card">
    <div className="modern-loader-animation">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <h3>Loading Complaints</h3>
    <p>Please wait while we fetch your complaint details...</p>
  </div>
</div>
          </div>
        </div>
      </>
    );
  }

    return (
    <>
    <div className='layout'>
      <Sidebar/>
        <div className="main-area">
          <Header/>
          <div className="container">
        <div className="top-hed-1">
          <div className='top-hed'>
            <h1>Complaint Management</h1>
            <p>Track and manage your complaints efficiently</p>
          </div>
          <div className='top-heds'>
          <button className="btns" onClick={() => setShowModal(true)}>+ Register New Complaint</button>
          </div>
        </div>
        {showModal && (
            <div className="modal-overlay">
              <div className="modal">
                <h2>Register Complaint</h2>
                {/* <input type="text"  name="subject" placeholder="Complaint Title"  value={formData.subject}  onChange={handleChange} /> */}
                <textarea placeholder="Complaint Description" name="description"  value={formData.description}  onChange={handleChange}></textarea>
                  
                <div className="modal-buttons">
                 
                  <button className="cancel-btn" onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                   <button className="submit-btn" onClick={handleSubmit}>Submit</button>
                </div>
              </div>
            </div>
          )}
          {showSuccess && (
  <div className="floating-success">
    <div className="success-left">
      <div className="success-check">✓</div>
    </div>

    <div className="success-content">
      <h4>Success</h4>
      <p>Complaint submitted successfully</p>
    </div>
  </div>
)}
        {/* Stats */} 
        <div className="statses">
          {statses.map((s, i) => (
            <div key={i} className="cards">
                <div
        className="stats-icon"
        style={{ color: s.color }}
      >
        {s.icon}
      </div>
              <h2>{s.value}</h2>
              <p>{s.label}</p>
            </div>
          ))}
        </div>
        <div className="filter-buttons">

  {["All", "Pending", "In Progress", "Resolved"].map((status) => (
    <button
      key={status}
      className={`filter-btn ${
        filterStatus === status ? "active-filter" : ""
      }`}
      onClick={() => {
        setFilterStatus(status);
        setCurrentPage(1);
      }}
    >
      {status}
    </button>
  ))}

</div>
        {/* Tabs & Search */}
        {/* <div className="topbar">
          <div className="tabs">
            {["All", "Pending", "In Progress", "Resolved"].map((t) => (
              <button key={t} className="tab">{t}</button>
            ))}
          </div>
          <input className="search" placeholder="Search complaints..." />
        </div> */}
       
        {/* Table */}
        <div className="table-wrapper">
        <table className="tables">
          <thead>
            <tr>
              <th>ID</th>
              {/* <th>Subject</th> */}
              <th>Complaints</th>
              <th>View</th>
              <th>Date</th>
              <th>Status</th>
              <th>Reply</th>
              <th>Rating</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            
            {currentComplaints.length > 0 ? (
              currentComplaints.map((c, i) => (
              <tr key={i}>
                <td className="id">{c.ticket_id}</td>
                {/* <td>{c.subject || "-"}</td> */}
                            <td> {c?.complaint
                  ? c.complaint.length > 15
                    ? c.complaint.substring(0, 15) + "..."
                    : c.complaint
                  : "-"}</td>
                  <td><button className="icons" onClick={() => handleView(c)}  style={{ cursor: "pointer", color: "#007bff", fontSize: "20px" }} >👁</button></td>
                         <td>
                    {c.complt_reg_dt
                      ? new Date(c.complt_reg_dt).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        }).replace(  "-")
                      : "-"}
                  </td>
                <td>
                <span className={`badges ${c?.status?.replace?.(" ", "").toLowerCase?.() || ""}`}>
                     {c?.status || "-"}
                </span>
                </td>
                
               <td>
  {c?.reply_content ? (
    <span
      style={{
        cursor: "pointer",
        color: "#007bff",
        fontSize: "20px"  
      }}
      onClick={() => {
        setSelectedMessage(c.reply_content);
        setShowPopup(true);
      }}
    >
      <LuMessageSquareMore />
    </span>
  ) : (
    <span
      style={{
        color: "#9ca3af",
        fontSize: "10px",
        fontWeight: "600"
      }}
    >
      No Reply
    </span>
  )}
</td>
            {showPopup && (
                  <div className="modal-overlay-reply">
                    <div className="modal-box-reply">
                      
                      <div className="modal-header-reply">
                        <h3>Reply Message</h3>
                        <span
                          className="close-icon"
                          onClick={() => setShowPopup(false)}
                        >
                          ✖
                        </span>
                      </div>

                      <div className="modal-body-reply">
                        <p>{selectedMessage}</p>
                      </div>

                      <div className="modal-footer-reply">
                        <button onClick={() => setShowPopup(false)}>Close</button>
                      </div>

                    </div>
                  </div>
                )}
                <td>
  {c?.status?.toLowerCase() === "resolved" ? (
    <span
      className="rating-badge"
     style={{
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        color: getRatingDisplay(c.rating || c.ratings).color,
        fontWeight: "600"
      }}
      onClick={() => {
          console.log("Selected Complaint:", c);
      setSelectedComplaintId(c.id );
        setShowRatingPopup(true);
      }}
    >
      {getRatingDisplay(c.rating || c.ratings).icon}
      {getRatingDisplay(c.rating || c.ratings).text}
    </span>
  ) : (
    <span className="no-reply">No reply yet</span>
  )}
</td>
             
              <td>
              <button
                className="icons delete"
                disabled={c?.status?.toLowerCase() !== "pending"}
                  onClick={() => {
                    setDeleteId(c.id);
                    setShowDeletePopup(true);
                  }}
                style={{
                  opacity: c?.status?.toLowerCase() !== "pending" ? 0.5 : 1,
                  cursor: c?.status?.toLowerCase() !== "pending" ? "not-allowed" : "pointer",
                  color: "#007bff", fontSize: "20px"
                }}
              
              >
                🗑
              </button>
            </td>
            {showDeletePopup && (
                  <div className="modal-overlay-reply">
                    <div className="modal-box-reply delete-popup">

                      <div className="modal-header-reply">
                        <h3>Delete Complaint</h3>

                        <span
                          className="close-icon"
                          onClick={() => {
                            setShowDeletePopup(false);
                            setDeleteId(null);
                          }}
                        >
                          ✖
                        </span>
                      </div>

                      <div className="modal-body-reply">
                        <p>Are you sure you want to delete this complaint?</p>
                      </div>

                      <div className="modal-footer-reply delete-buttons">
                        <button
                          className="cancel-delete-btn"
                          onClick={() => {
                            setShowDeletePopup(false);
                            setDeleteId(null);
                          }}
                        >
                          Cancel
                        </button>

                        <button
                          className="confirm-delete-btn"
                          onClick={handleDelete}
                        >
                          Delete
                        </button>
                      </div>

                    </div>
                  </div>
                )}
              </tr>
            ))) : (
              
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No complaints found.
                </td>
              </tr>
            )}
           
            {showViewModal && selectedComplaint && (
                <div className="modals-overlays">
                  <div className="modals">
                    <h2>Complaint Details</h2>
                    <p><strong>Complaint:</strong></p>
                    <p>{selectedComplaint.complaint}</p>
                 

                    <div className="modals-buttonss">
                      <button className="cancels-btns" onClick={closeViewModal}>
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              )}
          </tbody>
            <div className="pagination">
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index}
                  className={currentPage === index + 1 ? "active-page" : ""}
                  onClick={() => setCurrentPage(index + 1)}
                >
                  {index + 1}
                </button>
              ))}

              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
        </table>
        {showRatingPopup && (
  <div className="modal-overlay-reply">
    <div className="modal-box-reply">

      <div className="modal-header-reply">
        <h3>Give Rating</h3>
        <span
          className="close-icon"
          onClick={() => setShowRatingPopup(false)}
        >
          ✖
        </span>
      </div>

      <div className="modal-body-reply rating-options">
        <button onClick={() => handleRating("Excellent")}>
          <FaGrinStars className="icon excellent" />
          Excellent
        </button>

        <button onClick={() => handleRating("Good")}>
          <FaSmile className="icon good" />
          Good
        </button>

        <button onClick={() => handleRating("Average")}>
          <FaMeh className="icon average" />
          Average
        </button>

        <button onClick={() => handleRating("Bad")}>
          <FaMeh className="icon bad" />
          Bad
        </button>

        <button onClick={() => handleRating("Poor")}>
          <FaFrown className="icon poor" />
          Poor
        </button>
      </div>

    </div>
  </div>
)}
        </div>
      </div>
        </div>
    </div>
    </>
    )
  }

  export default Complaintregister